// Static cascade data for Indonesian provinces + regencies/cities.
// Focused on Jabodetabek (product's initial market) with full detail; other
// provinces list only the province name so admins can still tag schools nationwide.
// Structure: { name: string, cities: string[] } — pick city or kabupaten from the list.

export const INDONESIA_PROVINCES = [
  {
    name: "DKI Jakarta",
    cities: [
      "Jakarta Pusat", "Jakarta Utara", "Jakarta Barat",
      "Jakarta Selatan", "Jakarta Timur", "Kepulauan Seribu",
    ],
  },
  {
    name: "Banten",
    cities: [
      "Kota Tangerang", "Kota Tangerang Selatan", "Kabupaten Tangerang",
      "Kota Serang", "Kabupaten Serang", "Kota Cilegon",
      "Kabupaten Pandeglang", "Kabupaten Lebak",
    ],
  },
  {
    name: "Jawa Barat",
    cities: [
      "Kota Bogor", "Kabupaten Bogor", "Kota Depok",
      "Kota Bekasi", "Kabupaten Bekasi", "Kota Bandung",
      "Kabupaten Bandung", "Kabupaten Bandung Barat", "Kota Cimahi",
      "Kota Cirebon", "Kabupaten Cirebon", "Kota Sukabumi",
      "Kabupaten Sukabumi", "Kota Tasikmalaya", "Kabupaten Tasikmalaya",
      "Kabupaten Karawang", "Kabupaten Purwakarta", "Kabupaten Subang",
      "Kabupaten Indramayu", "Kabupaten Majalengka", "Kabupaten Kuningan",
      "Kabupaten Sumedang", "Kabupaten Ciamis", "Kota Banjar",
      "Kabupaten Pangandaran", "Kabupaten Garut",
    ],
  },
  { name: "Jawa Tengah", cities: [
      "Kota Semarang", "Kota Surakarta", "Kota Magelang", "Kota Salatiga",
      "Kota Pekalongan", "Kota Tegal", "Kabupaten Semarang", "Kabupaten Kudus",
      "Kabupaten Jepara", "Kabupaten Pati", "Kabupaten Cilacap", "Kabupaten Banyumas",
      "Kabupaten Purbalingga", "Kabupaten Banjarnegara", "Kabupaten Kebumen",
      "Kabupaten Purworejo", "Kabupaten Wonosobo", "Kabupaten Temanggung",
      "Kabupaten Kendal", "Kabupaten Batang", "Kabupaten Pekalongan",
      "Kabupaten Pemalang", "Kabupaten Tegal", "Kabupaten Brebes",
      "Kabupaten Boyolali", "Kabupaten Klaten", "Kabupaten Sukoharjo",
      "Kabupaten Wonogiri", "Kabupaten Karanganyar", "Kabupaten Sragen",
      "Kabupaten Grobogan", "Kabupaten Blora", "Kabupaten Rembang",
      "Kabupaten Demak", "Kabupaten Magelang",
  ] },
  { name: "DI Yogyakarta", cities: [
      "Kota Yogyakarta", "Kabupaten Sleman", "Kabupaten Bantul",
      "Kabupaten Kulon Progo", "Kabupaten Gunungkidul",
  ] },
  { name: "Jawa Timur", cities: [
      "Kota Surabaya", "Kota Malang", "Kabupaten Malang", "Kota Batu",
      "Kota Kediri", "Kabupaten Kediri", "Kota Blitar", "Kabupaten Blitar",
      "Kota Madiun", "Kabupaten Madiun", "Kota Mojokerto", "Kabupaten Mojokerto",
      "Kota Pasuruan", "Kabupaten Pasuruan", "Kota Probolinggo", "Kabupaten Probolinggo",
      "Kabupaten Sidoarjo", "Kabupaten Gresik", "Kabupaten Jombang", "Kabupaten Nganjuk",
      "Kabupaten Bojonegoro", "Kabupaten Tuban", "Kabupaten Lamongan", "Kabupaten Ngawi",
      "Kabupaten Magetan", "Kabupaten Ponorogo", "Kabupaten Pacitan", "Kabupaten Trenggalek",
      "Kabupaten Tulungagung", "Kabupaten Lumajang", "Kabupaten Jember", "Kabupaten Bondowoso",
      "Kabupaten Situbondo", "Kabupaten Banyuwangi", "Kabupaten Sumenep", "Kabupaten Pamekasan",
      "Kabupaten Sampang", "Kabupaten Bangkalan",
  ] },
  { name: "Bali", cities: [
      "Kota Denpasar", "Kabupaten Badung", "Kabupaten Gianyar", "Kabupaten Tabanan",
      "Kabupaten Buleleng", "Kabupaten Karangasem", "Kabupaten Klungkung",
      "Kabupaten Bangli", "Kabupaten Jembrana",
  ] },
  { name: "Aceh", cities: [] },
  { name: "Sumatera Utara", cities: ["Kota Medan","Kota Binjai","Kota Pematang Siantar","Kota Tebing Tinggi"] },
  { name: "Sumatera Barat", cities: ["Kota Padang","Kota Bukittinggi","Kota Payakumbuh","Kota Solok"] },
  { name: "Riau", cities: ["Kota Pekanbaru","Kota Dumai"] },
  { name: "Kepulauan Riau", cities: ["Kota Batam","Kota Tanjungpinang"] },
  { name: "Jambi", cities: ["Kota Jambi"] },
  { name: "Sumatera Selatan", cities: ["Kota Palembang","Kota Lubuklinggau"] },
  { name: "Bangka Belitung", cities: ["Kota Pangkalpinang"] },
  { name: "Bengkulu", cities: ["Kota Bengkulu"] },
  { name: "Lampung", cities: ["Kota Bandar Lampung","Kota Metro"] },
  { name: "Kalimantan Barat", cities: ["Kota Pontianak","Kota Singkawang"] },
  { name: "Kalimantan Tengah", cities: ["Kota Palangka Raya"] },
  { name: "Kalimantan Selatan", cities: ["Kota Banjarmasin","Kota Banjarbaru"] },
  { name: "Kalimantan Timur", cities: ["Kota Samarinda","Kota Balikpapan","Kota Bontang"] },
  { name: "Kalimantan Utara", cities: ["Kota Tarakan"] },
  { name: "Sulawesi Utara", cities: ["Kota Manado","Kota Bitung"] },
  { name: "Sulawesi Tengah", cities: ["Kota Palu"] },
  { name: "Sulawesi Selatan", cities: ["Kota Makassar","Kota Parepare","Kota Palopo"] },
  { name: "Sulawesi Tenggara", cities: ["Kota Kendari","Kota Baubau"] },
  { name: "Gorontalo", cities: ["Kota Gorontalo"] },
  { name: "Sulawesi Barat", cities: ["Kabupaten Mamuju"] },
  { name: "Nusa Tenggara Barat", cities: ["Kota Mataram","Kota Bima"] },
  { name: "Nusa Tenggara Timur", cities: ["Kota Kupang"] },
  { name: "Maluku", cities: ["Kota Ambon","Kota Tual"] },
  { name: "Maluku Utara", cities: ["Kota Ternate","Kota Tidore Kepulauan"] },
  { name: "Papua", cities: ["Kota Jayapura"] },
  { name: "Papua Barat", cities: ["Kota Sorong"] },
  { name: "Papua Selatan", cities: [] },
  { name: "Papua Tengah", cities: [] },
  { name: "Papua Pegunungan", cities: [] },
  { name: "Papua Barat Daya", cities: [] },
];

export const PROVINCE_NAMES = INDONESIA_PROVINCES.map((p) => p.name);

export function getCitiesForProvince(name) {
  const p = INDONESIA_PROVINCES.find((x) => x.name === name);
  return p ? p.cities : [];
}
